/**!
 * <script src="js/mobile.js"></script>
 */
$(document).ready(function() {
    // variable block;
    var smallBottleNonContLink = "https://www2.gutcleanseprotocol.com/fst/1_unit_biocomplete3_destination";
    var mediumBottleNonContLink = 'https://www2.gutcleanseprotocol.com/fst/3_unit_biocomplete3_destination';
    var largeBottleNonContLink = 'https://www2.gutcleanseprotocol.com/fst/6_unit_biocomplete3_destination';
    var smallBottleContLink = "https://www2.gutcleanseprotocol.com/fst/d_biocomplete3_1unitsub_mf_210809";
    var mediumBottleContLink = "https://www2.gutcleanseprotocol.com/fst/d_biocomplete3_3unitsub_mf_210809";
    var largeBottleContLink = "https://www2.gutcleanseprotocol.com/fst/d_biocomplete3_6unitsub_mf_210809";

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    // toggling of cont vs nonCONT
    $('.contOrNonContToggle').click(function(){
        var currentToggle = $('.contOrNonContToggle.active');
        if($(this).hasClass('active')) {
            return;
        }
        else {
            $(this).toggleClass('active');
            $(currentToggle).removeClass('active');
        }
    })
    // order options nonCont
    $('.mobileorder_nonCont_qty').click(function() {
        var currentQty = $('.mobileorder_nonCont_qty.active');
        if($(this).hasClass('active')) {
            return;
        }
        else {
            $(this).toggleClass('active');
        }
        $(currentQty).removeClass('active');
        var currentContQty = $('.mobileorder_subscription_qty.active');
        $(currentContQty).removeClass('active');
        if($(this).hasClass('smallQty')) {
            // // setting price for subscription while on Non Cont
            $('.mobileorder_subscription_qty.smallQty').addClass('active');
            $('.mobileorder_subscription_buyNow').attr('href', smallBottleContLink  + queryString);
            $('.mobileorder_subscription_pricePerJar').html('$44.95 Per Bottle');
            $('.mobileorder_subscription_retailPrice').html('Retail: $69.95');
            $('.mobileorder_subscription_offerPrice_numb').html('$44.95');
            //  end
            // setting price details for non Cont
            $('.mobileorder_nonCont_buyNow').attr('href', smallBottleNonContLink + queryString);
            $('.mobileorder_nonCont_pricePerJar').html('$49.95 Per Bottle');
            $('.mobileorder_nonCont_retailPrice').html('Retail: $69.95');
            $('.mobileorder_nonCont_offerPrice_numb').html('$49.95');
        }
        else if($(this).hasClass('mediumQty')){
            // setting price for subscription while on Non Cont
            $('.mobileorder_subscription_qty.mediumQty').addClass('active');
            $('.mobileorder_subscription_buyNow').attr('href', mediumBottleContLink  + queryString);
            $('.mobileorder_subscription_pricePerJar').html('$40.65 Per Bottle');
            $('.mobileorder_subscription_retailPrice').html('Retail: $209.85');
            $('.mobileorder_subscription_offerPrice_numb').html('$121.95');

            // setting price for Non Cont
            $('.mobileorder_nonCont_buyNow').attr('href', mediumBottleNonContLink + queryString);
            $('.mobileorder_nonCont_pricePerJar').html('$44.95 Per Bottle');
            $('.mobileorder_nonCont_retailPrice').html('Retail: $209.85');
            $('.mobileorder_nonCont_offerPrice_numb').html('$134.85');
        }
        else{
            // setting price for subscription while on Non Cont
            $('.mobileorder_subscription_qty.largeQty').addClass('active');
            $('.mobileorder_subscription_buyNow').attr('href', largeBottleContLink  + queryString);
            $('.mobileorder_subscription_pricePerJar').html('$36.95 Per Bottle');
            $('.mobileorder_subscription_retailPrice').html('Retail: $419.70');
            $('.mobileorder_subscription_offerPrice_numb').html('$229.95');
            
            // setting price for Non Cont
            $('.mobileorder_nonCont_buyNow').attr('href', largeBottleNonContLink + queryString) ;
            $('.mobileorder_nonCont_pricePerJar').html('$42.45 Per Bottle');
            $('.mobileorder_nonCont_retailPrice').html('Retail: $419.70');
            $('.mobileorder_nonCont_offerPrice_numb').html('$254.70');
        }
    });
     // order options continuity
     $('.mobileorder_subscription_qty').click(function() {
        var currentQty = $('.mobileorder_subscription_qty.active');
        if($(this).hasClass('active')) {
            return;
        }
        else {
            $(this).toggleClass('active');
        }
        $(currentQty).removeClass('active');

        var currentNonContQty = $('.mobileorder_nonCont_qty.active');
        $(currentNonContQty).removeClass('active');
        if($(this).hasClass('smallQty')) {
            // setting the non cont prices while on cont
            $('.mobileorder_nonCont_qty.smallQty').addClass('active');
            $('.mobileorder_nonCont_buyNow').attr('href', smallBottleNonContLink + queryString);
            $('.mobileorder_nonCont_pricePerJar').html('$49.95 Per Bottle');
            $('.mobileorder_nonCont_retailPrice').html('Retail: $69.95');
            $('.mobileorder_nonCont_offerPrice_numb').html('$49.95');
            
            //  end
            // setting price details for cont
            $('.mobileorder_subscription_qty.smallQty').addClass('active');
            $('.mobileorder_subscription_buyNow').attr('href', smallBottleContLink  + queryString);
            $('.mobileorder_subscription_pricePerJar').html('$44.95 Per Bottle');
            $('.mobileorder_subscription_retailPrice').html('Retail: $69.95');
            $('.mobileorder_subscription_offerPrice_numb').html('$44.95');
        }
        else if($(this).hasClass('mediumQty')){
            // setting the non cont prices while on cont
            $('.mobileorder_nonCont_qty.mediumQty').addClass('active');
            $('.mobileorder_nonCont_pricePerJar').html('$44.95 Per Bottle');
            $('.mobileorder_nonCont_retailPrice').html('Retail: $209.85');
            $('.mobileorder_nonCont_offerPrice_numb').html('$134.85');
            $('.mobileorder_nonCont_buyNow').attr('href', mediumBottleNonContLink + queryString);

            // setting cont prices
            $('.mobileorder_subscription_qty.mediumQty').addClass('active');
            $('.mobileorder_subscription_buyNow').attr('href', mediumBottleContLink  + queryString);
            $('.mobileorder_subscription_pricePerJar').html('$40.65 Per Bottle');
            $('.mobileorder_subscription_retailPrice').html('Retail: $209.85');
            $('.mobileorder_subscription_offerPrice_numb').html('$121.95');
        }
        else{
            // setting the non cont prices while on cont
            $('.mobileorder_nonCont_qty.largeQty').addClass('active');
            $('.mobileorder_nonCont_buyNow').attr('href', largeBottleNonContLink + queryString) ;
            $('.mobileorder_nonCont_pricePerJar').html('$42.45 Per Bottle');
            $('.mobileorder_nonCont_retailPrice').html('Retail: $419.70');
            $('.mobileorder_nonCont_offerPrice_numb').html('$254.70');
            // setting the cont prices
            $('.mobileorder_subscription_qty.largeQty').addClass('active');
            $('.mobileorder_subscription_buyNow').attr('href', largeBottleContLink  + queryString);
            $('.mobileorder_subscription_pricePerJar').html('$38.33 Per Bottle');
            $('.mobileorder_subscription_retailPrice').html('Retail: $419.70');
            $('.mobileorder_subscription_offerPrice_numb').html('$229.95');
        }
        
    });
    // faq toggling
    $('.faqs').click(function() {
        $(this).find('.faqInformation').slideToggle("slow", function() {
            
        });
    });

    // continuity opt-in logic
    $('.continuity_wrap').click(function() {
        $(this).find('img').toggle();
    });
    // $('.continuity_wrap').click(function() {
    //     $('.mobileorder_subscription_buyNow').toggleClass('disabled');
    // });
    
})

/**!
 * <script src="js/osDesktop.js"></script>
 */
$(document).ready(function () {
    const urlParams = window.location.search;
    $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnesswatermelon_3unit_mf_230308' + urlParams);
    //Initialize Values
    let unitSelected = 3;
    let flavorSelected = 'raspberry';
    var optedin = false;
    var subscribePicked;
    
    //Function to Switch flavors
    var flavorSwitch = function() {
        if(flavorSelected == 'watermelon'){
            $('.banner_product_section_desktop').removeClass('flavor-raspberry');
            $('.banner_product_section_desktop').addClass('flavor-watermelon');
            $('.banner_product_section_desktop').find('.select_flavors').removeClass('flavor-raspberry');
            $('.banner_product_section_desktop').find('.select_flavors').addClass('flavor-watermelon');
            $('.banner_product_section_desktop').find('.sel_flavor').removeClass('active');
            $('.banner_product_section_desktop').find('.sel_flavor:nth-child(1)').addClass('active');
            $('.buyButton.productSection_text_orderNow_btn ').removeClass('flavor-raspberry');
            //$('.buyButton.productSection_text_orderNow_btn ').removeClass('disabled');
            $('.buyButton.productSection_text_orderNow_btn ').addClass('flavor-watermelon');
            $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnesswatermelon_3unit_mf_230308' + urlParams);
            $('.variable_productImageVanilla').attr('src','https://cdn.gundrymd.com/images/drg-mct-wellness-watermelon-lemonade.png');     
            $('.variable_suppFactsVanilla').attr('src','https://cdn.gundrymd.com/images/MCT_Wellness_Watermelon_SFP.png');
            $('.faq_supp_desk').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Watermelon_SFP.png');
        }
        else{
            $('.banner_product_section_desktop').removeClass('flavor-watermelon');
            $('.banner_product_section_desktop').addClass('flavor-raspberry');
            $('.banner_product_section_desktop').find('.select_flavors').removeClass('flavor-watermelon');
            $('.banner_product_section_desktop').find('.select_flavors').addClass('flavor-raspberry');
            $('.banner_product_section_desktop').find('.sel_flavor').removeClass('active');
            $('.banner_product_section_desktop').find('.sel_flavor:nth-child(2)').addClass('active');
            $('.buyButton.productSection_text_orderNow_btn ').removeClass('flavor-watermelon');
            //$('.buyButton.productSection_text_orderNow_btn ').removeClass('disabled');
            $('.buyButton.productSection_text_orderNow_btn ').addClass('flavor-raspberry');
            $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnessraspberry_3unit_mf_230308' + urlParams);
            $('.variable_productImageVanilla').attr('src','https://cdn.gundrymd.com/images/Watermelon_Pink-opt.png');
            $('.variable_suppFactsVanilla').attr('src','https://cdn.gundrymd.com/images/MCT_Wellness_Raspberry_SFP_v0.png');
            $('.faq_supp_desk').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Raspberry_SFP_v0.png');
        }
    }

    flavorSwitch();
    
    // variable functions
    var packagepick = function () {
        var pkg = $('.pkg-pick').find(":selected").attr('id');
        var subscribe = $("input[name='subscribe']:checked").val();
        //alert(pkg);
        //Switch for value
        //alert('Unit: ' + unitSele cted);
        //alert('Flavor: '+ flavorSelected);
        //alert('Subscribed: ' + subscribePicked);

        $('.buyButton').removeClass('flavor-watermelon flavor-raspberry');
        $('.buyButton').addClass('flavor-' + flavorSelected);

        // if (flavorSelected == "raspberry")
        //     $(".raspberry-disclaimer").slideDown();
        // else
        //     $(".raspberry-disclaimer").slideUp();

        if (subscribePicked)
            $(".plan-sub-txt").html("Monthly Subscription");
        else
            $(".plan-sub-txt").html("One-Time Payment");

        if (flavorSelected == 'watermelon') {
            switch (unitSelected) {
                case 1:
                    if (subscribePicked) {
                        //Sub Prices
                        $('.pinfo-initial-price').html('79.95');
                        //$('.pinfo-member-savings').html('5.00');
                        $('.pinfo-instant-savings').html('35.00');
                        $('.pinfo-final-price').html('44.95');
                        //$('.sub-section').find('.sub-price').html('44.95');
                        //$('.sub-section').find('.reg-price').html('49.95')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnesswatermelon_1unitsub_mf_230308' + urlParams);
                    }
                    else {
                        //One-Time Prices
                        $('.pinfo-initial-price').html('79.95');
                        //$('.pinfo-member-savings').html('5.00');
                        $('.pinfo-instant-savings').html('30.00');
                        $('.pinfo-final-price').html('49.95');
                        //$('.sub-section').find('.sub-price').html('44.95');
                        //$('.sub-section').find('.reg-price').html('49.95')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnesswatermelon_1unit_mf_230308' + urlParams);
                    }
                    break;
                case 3:
                    if (subscribePicked) {
                        //Sub Prices
                        $('.pinfo-initial-price').html('239.85');
                        //$('.pinfo-member-savings').html('15.00');
                        $('.pinfo-instant-savings').html('120.00');
                        $('.pinfo-final-price').html('119.85');
                        //$('.sub-section').find('.sub-price').html('119.85');
                        //$('.sub-section').find('.reg-price').html('139.85')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnesswatermelon_3unitsub_mf_230308' + urlParams);
                    }
                    else {
                        //One-Time Prices
                        $('.pinfo-initial-price').html('239.85');
                        //$('.pinfo-member-savings').html('15.00');
                        $('.pinfo-instant-savings').html('100.00');
                        $('.pinfo-final-price').html('139.85');
                        //$('.sub-section').find('.sub-price').html('119.85');
                        //$('.sub-section').find('.reg-price').html('139.85')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnesswatermelon_3unit_mf_230308' + urlParams);
                    }
                    break;
                default:
                    if (subscribePicked) {
                        //Sub Prices
                        $('.pinfo-initial-price').html('479.70');
                        //$('.pinfo-member-savings').html('30.00');
                        $('.pinfo-instant-savings').html('258.00');
                        $('.pinfo-final-price').html('221.70');
                        //$('.sub-section').find('.sub-price').html('221.70');
                        //$('.sub-section').find('.reg-price').html('269.70')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnesswatermelon_6unitsub_mf_230308' + urlParams);
                    }
                    else {
                        //One-Time Prices
                        $('.pinfo-initial-price').html('479.70');
                        //$('.pinfo-member-savings').html('30.00');
                        $('.pinfo-instant-savings').html('210.00');
                        $('.pinfo-final-price').html('269.70');
                        //$('.sub-section').find('.sub-price').html('221.70');
                        //$('.sub-section').find('.reg-price').html('269.70')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnesswatermelon_6unit_mf_230308' + urlParams);
                    }
            }
        }
        else {
            //Raspberry
            switch (unitSelected) {
                case 1:
                    if (subscribePicked) {
                        //Sub Prices
                        $('.pinfo-initial-price').html('79.95');
                        //$('.pinfo-member-savings').html('5.00');
                        $('.pinfo-instant-savings').html('35.00');
                        $('.pinfo-final-price').html('44.95');
                        //$('.sub-section').find('.sub-price').html('44.95');
                        //$('.sub-section').find('.reg-price').html('49.95')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnessraspberry_1unitsub_mf_230308' + urlParams);
                    }
                    else {
                        //One-Time Prices
                        $('.pinfo-initial-price').html('79.95');
                        //$('.pinfo-member-savings').html('5.00');
                        $('.pinfo-instant-savings').html('30.00');
                        $('.pinfo-final-price').html('49.95');
                        //$('.sub-section').find('.sub-price').html('44.95');
                        //$('.sub-section').find('.reg-price').html('49.95')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnessraspberry_1unit_mf_230308' + urlParams);
                    }
                    break;
                case 3:
                    if (subscribePicked) {
                        //Sub Prices
                        $('.pinfo-initial-price').html('239.85');
                        //$('.pinfo-member-savings').html('15.00');
                        $('.pinfo-instant-savings').html('120.00');
                        $('.pinfo-final-price').html('119.85');
                        //$('.sub-section').find('.sub-price').html('119.85');
                        //$('.sub-section').find('.reg-price').html('139.85')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnessraspberry_3unitsub_mf_230308' + urlParams);
                    }
                    else {
                        //One-Time Prices
                        $('.pinfo-initial-price').html('239.85');
                        //$('.pinfo-member-savings').html('15.00');
                        $('.pinfo-instant-savings').html('100.00');
                        $('.pinfo-final-price').html('139.85');
                        //$('.sub-section').find('.sub-price').html('119.85');
                        //$('.sub-section').find('.reg-price').html('139.85')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnessraspberry_3unit_mf_230308' + urlParams);
                    }
                    break;
                default:
                    if (subscribePicked) {
                        //Sub Prices
                        $('.pinfo-initial-price').html('479.70');
                        //$('.pinfo-member-savings').html('30.00');
                        $('.pinfo-instant-savings').html('258.00');
                        $('.pinfo-final-price').html('221.70');
                        //$('.sub-section').find('.sub-price').html('221.70');
                        //$('.sub-section').find('.reg-price').html('269.70')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnessraspberry_6unitsub_mf_230308' + urlParams);
                    }
                    else {
                        //One-Time Prices
                        $('.pinfo-initial-price').html('479.70');
                        //$('.pinfo-member-savings').html('30.00');
                        $('.pinfo-instant-savings').html('210.00');
                        $('.pinfo-final-price').html('269.70');
                        //$('.sub-section').find('.sub-price').html('221.70');
                        //$('.sub-section').find('.reg-price').html('269.70')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnessraspberry_6unit_mf_230308' + urlParams);
                    }
            }
        }
    }
    

    //Header
    /*$(window).scroll(function() {
        var scroll = $(window).scrollTop();
        var topOffer = parseInt($('.stickTop').css('height'));
        if (scroll >= topOffer) {
            $(".stickTop").addClass("release");
        }
        else{
            $(".stickTop").removeClass("release");
        }
    });*/
    //missing );

    //Package Unit Select
    $('.pkg-unit').click(function () {
        unitSelected = parseInt($(this).attr('data-unit'));
        var unitId = '#' + $(this).attr('id');
        $('.pkg-unit').removeClass('active');
        $(this).addClass('active');
        $('.banner_product_section_desktop').find('.sel_qty').removeClass('active');
        $('.banner_product_section_desktop').find(unitId).addClass('active');
        packagepick();
    })

    
    $('.banner_product_section_desktop_only').find('.sub-section').click(function () {
        var subscriptionId = '#' + $(this).attr('id');
        $('.sub-section').removeClass('active');
        $('.banner_product_section_desktop').find('.sel_pay').removeClass('active');
        $(this).addClass('active');
        $('.banner_product_section_desktop').find(subscriptionId).addClass('active');
        if ($(this).attr('id') == 'onetime') {
            subscribePicked = false;
            $('.productSection_text_orderNow_btn').removeClass('disabled');
            $('.cart-section').removeClass('disabled');
            $('.subdisclaimer').removeClass('active');
            $('.banner_product_section_desktop_only').find('.sub-check').prop("checked", false);
            $('.sticky-footer-desktop').find('.sub-check').prop("checked", false);
            $('.sticky-footer-desktop').find('label').removeClass('addCheck');
            $('.banner_product_section_desktop_only').find('label').removeClass('addCheck');
            optedin = false;
            if (!$('.onetime-container').hasClass('active')) {
                $('.onetime-container').addClass('active');
            }
        }
        else {
            subscribePicked = true;
            if (optedin == false) {
                $('.productSection_text_orderNow_btn').addClass('disabled');
                $('.cart-section').addClass('disabled');
            }
            $('.onetime-container').removeClass('active');
            if (!$('.subdisclaimer').hasClass('active')) {
                $('.subdisclaimer').addClass('active');
            }
        }
        packagepick();
    })

    $('.pkg-flavor').click(function () {
        //Change Active Flavor, rename popup-body
        flavorSelected = $(this).attr('data-flavor');
        flavorId = '#' + flavorSelected;
        //console.log(flavorId);
        var oldFlavor = 'flavor-' + $('.pkg-flavor.active').attr('data-flavor');
        //console.log(oldFlavor);
        $('.popup-body').removeClass(oldFlavor);
        $('.banner_product_section_desktop').removeClass(oldFlavor);
        $('.cart-section').removeClass(oldFlavor);
        $('.cart-section').addClass('flavor-' + flavorSelected);
        if (flavorSelected == 'raspberry') {
            $('.carousel-indicators').find('.variable_productImageVanilla').attr('src', 'https://cdn.gundrymd.com/images/Watermelon_Pink-opt.png');
            $('.carousel-inner').find('.variable_productImageVanilla').attr('src', 'https://cdn.gundrymd.com/images/Watermelon_Pink-opt.png');
            $('.carousel-indicators').find('.variable_suppFactsVanilla').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Raspberry_SFP_v0.png');
            $('.carousel-inner').find('.variable_suppFactsVanilla').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Raspberry_SFP_v0.png');
            $('.faq_supp_desk').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Raspberry_SFP_v0.png');
        }
        else {
            $('.carousel-indicators').find('.variable_productImageVanilla').attr('src', 'https://cdn.gundrymd.com/images/drg-mct-wellness-watermelon-lemonade.png');
            $('.carousel-inner').find('.variable_productImageVanilla').attr('src', 'https://cdn.gundrymd.com/images/drg-mct-wellness-watermelon-lemonade.png');
            $('.carousel-indicators').find('.variable_suppFactsVanilla').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Watermelon_SFP.png');
            $('.carousel-inner').find('.variable_suppFactsVanilla').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Watermelon_SFP.png');
            $('.faq_supp_desk').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Watermelon_SFP.png');
        }
        $('.popup-body').addClass('flavor-' + flavorSelected);
        $('.banner_product_section_desktop').addClass('flavor-' + flavorSelected);
        $('.pkg-flavor').removeClass('active');
        $('.banner_product_section_desktop').find('.sel_flavor').removeClass('active');
        $(this).addClass('active');
        $('.banner_product_section_desktop').find(flavorId).addClass('active');
        packagepick();
    })

    //Banner Options
    //Package Unit Select
    $('.banner_product_section_desktop').find('.sel_qty').click(function () {
        unitSelected = parseInt($(this).attr('data-unit'));
        var unitId = '#' + $(this).attr('id');
        $('.pkg-unit').removeClass('active');
        $('.sel_qty_container').removeClass('active');
        $(this).parent('.sel_qty_container').addClass('active');
        $('.sticky-footer').find(unitId).addClass('active');
        $('.banner_product_section_desktop').find('.sel_qty').removeClass('active');
        $(this).addClass('active');
        packagepick();
    })
    $('.banner_product_section_desktop').find('.sel_qty_flag').click(function () {
        
        $(this).parent('.sel_qty_container').find('.sel_qty').click();
    })

    $('.banner_product_section_desktop_only').find('.sel_pay').click(function () {
        var subscriptionId = '#' + $(this).attr('id');
        $('.sub-section').removeClass('active');
        $('.banner_product_section_desktop').find('.sel_pay').removeClass('active');
        $(this).addClass('active');
        $('.sticky-footer').find(subscriptionId).addClass('active');
        if ($(this).attr('id') == 'onetime') {
            subscribePicked = false;
            $('.productSection_text_orderNow_btn').removeClass('disabled');
            $('.cart-section').removeClass('disabled');
            //$('.sticky-footer').find('.subdisclaimer').removeClass('active');
            $('.banner_product_section_desktop_only').find('.subdisclaimer').removeClass('active');
            $('.banner_product_section_desktop_only').find('.sub-check').prop("checked", false);
            $('.sticky-footer-desktop').find('.sub-check').prop("checked", false);
            $('.sticky-footer-desktop').find('label').removeClass('addCheck');
            $('.banner_product_section_desktop_only').find('label').removeClass('addCheck');
            optedin = false;
            if (!$('.onetime-container').hasClass('active')) {
                $('.onetime-container').addClass('active');
            }
        }
        else {
            if ($('.plan-popup').hasClass('hidden')) {
                $('.plan-popup').removeClass('hidden');
                //$('.popup-overlay').show();
                $('.tooltiptext').fadeIn(1500);
                $('.tooltiptext').fadeOut(4000);F
            }
            subscribePicked = true;
            if (optedin == false) {
                $('.productSection_text_orderNow_btn').addClass('disabled');
                $('.cart-section').addClass('disabled');
            }
            $('.onetime-container').removeClass('active');
            /*if (!$('.sticky-footer').find('.subdisclaimer').hasClass('active')) {
                $('.sticky-footer').find('.subdisclaimer').addClass('active');
            }*/
            if (!$('.banner_product_section_desktop_only').find('.subdisclaimer').hasClass('active')) {
                $('.banner_product_section_desktop_only').find('.subdisclaimer').addClass('active');
            }
        }
        packagepick();
    })

    $('.banner_product_section_desktop').find('.sel_flavor').click(function () {
        //Change Active Flavor, rename popup-body
        flavorSelected = $(this).attr('data-flavor');
        flavorId = '#' + flavorSelected;
        //console.log(flavorId);
        var oldFlavor = 'flavor-' + $('.pkg-flavor.active').attr('data-flavor');
        //console.log(oldFlavor);
        $('.popup-body').removeClass(oldFlavor);
        $('.banner_product_section_desktop').removeClass(oldFlavor);
        $('.cart-section').removeClass(oldFlavor);
        $('.cart-section').addClass('flavor-' + flavorSelected);
        if (flavorSelected == 'raspberry') {
            $('.carousel-indicators').find('.variable_productImageVanilla').attr('src', 'https://cdn.gundrymd.com/images/Watermelon_Pink-opt.png');
            $('.carousel-inner').find('.variable_productImageVanilla').attr('src', 'https://cdn.gundrymd.com/images/Watermelon_Pink-opt.png');
            $('.carousel-indicators').find('.variable_suppFactsVanilla').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Raspberry_SFP_v0.png');
            $('.carousel-inner').find('.variable_suppFactsVanilla').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Raspberry_SFP_v0.png');
            $('.faq_supp_desk').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Raspberry_SFP_v0.png');
        }
        else {
            $('.carousel-indicators').find('.variable_productImageVanilla').attr('src', 'https://cdn.gundrymd.com/images/drg-mct-wellness-watermelon-lemonade.png');
            $('.carousel-inner').find('.variable_productImageVanilla').attr('src', 'https://cdn.gundrymd.com/images/drg-mct-wellness-watermelon-lemonade.png');
            $('.carousel-indicators').find('.variable_suppFactsVanilla').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Watermelon_SFP.png');
            $('.carousel-inner').find('.variable_suppFactsVanilla').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Watermelon_SFP.png');
            $('.faq_supp_desk').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Watermelon_SFP.png');
        }
        $('.popup-body').addClass('flavor-' + flavorSelected);
        $('.banner_product_section_desktop').addClass('flavor-' + flavorSelected);
        $('.pkg-flavor').removeClass('active');
        $('.banner_product_section_desktop').find('.sel_flavor').removeClass('active');
        $(this).addClass('active');
        $('.sticky-footer').find(flavorId).addClass('active');
        packagepick();
    })

    $('.productSection_text_orderNow_btn').click(function () {
        if (!$(this).hasClass('disabled')) {
            window.location.href = $(this).attr('data-link');
        }
        else {
            $('.subdis-top').addClass('with-border');
        }
    })

    //Pick
    $(".pkg-pick").change(function () {
        packagepick();
    });

    /*$('.sub-section').click(function(){
        var idvalue = $(this).attr('id');
        var ifcheck = $(this).hasClass('active');
        var checkedsub = $('.sub-check').prop("checked");
        if(!ifcheck){
            $('.sub-section').removeClass('active');
            $(this).addClass('active');
            $(this).children('.radio-sub').prop("checked", true);
            if(idvalue == 'subscribe'){
                $('.subdisclaimer').show();
                if(!checkedsub){
                    $('.productSection_text_orderNow_btn').addClass('disabled');
                }
                //$('.cart-btn').addClass('noaction');
            }
            else{
                $('.subdisclaimer').hide();
                $('.productSection_text_orderNow_btn').removeClass('disabled');
                //$('.cart-btn').removeClass('noaction');
            }
        }
        packagepick();
    })*/

    $('#purchase-form-desk').submit(function () {
        if (!$('.productSection_text_orderNow_btn').hasClass('disabled')) {
            var link = $('.productSection_text_orderNow_btn').attr('data-link');
            window.location.href = link;
        }
    })

    $('.sticky-footer-desktop').find('.sub-label-opt').click(function () {
        //alert('ayo');
        var checkedif = $('.sticky-footer-desktop').find('.sub-label-opt').hasClass('addCheck');
        if (!checkedif) {
            $('.productSection_text_orderNow_btn').removeClass('disabled');
            $('.sticky-footer-desktop').find('.cart-section').removeClass('disabled');
            optedin = true;
            $('.subdis-top').find('label').addClass('addCheck');
            $('.subdis-top').removeClass('with-border');
            //$('.check-png').show();
        }
        else {
            $('.productSection_text_orderNow_btn').addClass('disabled');
            $('.cart-section').removeClass('disabled');
            $('.subdis-top').find('label').removeClass('addCheck');
            optedin = false;
        }
        /*if(this.checked) {
            var returnVal = confirm("Are you sure?");
            $(this).prop("checked", returnVal);
        }
        $('#textbox1').val(this.checked);*/
    });
    $('.banner_product_section_desktop_only').find('.sub-label').click(function () {
        //alert('ayo');
        var checkedif = $('.sticky-footer-desktop').find('.sub-label-opt').hasClass('addCheck');
        if (!checkedif) {
            $('.productSection_text_orderNow_btn').removeClass('disabled');
            $('.sticky-footer-desktop').find('.cart-section').removeClass('disabled');
            optedin = true;
            $('.subdis-top').find('label').addClass('addCheck');
            $('.subdis-top').removeClass('with-border');
            //$('.check-png').show();
        }
        else {
            $('.productSection_text_orderNow_btn').addClass('disabled');
            $('.cart-section').removeClass('disabled');
            $('.subdis-top').find('label').removeClass('addCheck');
            optedin = false;
        }
        /*if(this.checked) {
            var returnVal = confirm("Are you sure?");
            $(this).prop("checked", returnVal);
        }
        $('#textbox1').val(this.checked);*/
    });
    $('.banner_product_section_desktop_only').find('.sub-label-opt').click(function () {
        //alert('ayo');
        var checkedif = $('.sticky-footer-desktop').find('.sub-label-opt').hasClass('addCheck');
        if (!checkedif) {
            $('.productSection_text_orderNow_btn').removeClass('disabled');
            $('.sticky-footer-desktop').find('.cart-section').removeClass('disabled');
            optedin = true;
            $('.subdis-top').find('label').addClass('addCheck');
            $('.subdis-top').removeClass('with-border');
            //$('.check-png').show();
        }
        else {
            $('.productSection_text_orderNow_btn').addClass('disabled');
            $('.cart-section').removeClass('disabled');
            $('.subdis-top').find('label').removeClass('addCheck');
            optedin = false;
        }
        /*if(this.checked) {
            var returnVal = confirm("Are you sure?");
            $(this).prop("checked", returnVal);
        }
        $('#textbox1').val(this.checked);*/
    });

    /*$('.productSection_text_orderNow_btn').click(function(){
        if(!$this.hasClass('disabled')){
            var link = $(this).data('link');
            window.location.href = link;
        }
    })*/

    // Adding the class of Active

    // slow scroll
    $(".orderpage_btnB").click(function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(".product_section").offset().top - 100
        }, 1000);
    });

    $('.productSection_text_orderScroll').click(function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(".product_section").offset().top - 100
        }, 1000);
    });

    $('.header_cta').click(function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(".product_section").offset().top - 100
        }, 1000);
    });

    $('.reviews_header').click(function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(".swiper_container").offset().top - 100
        }, 1000);
    });

    $('.gut_header').click(function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(".ChangeOneThing").offset().top - 100
        }, 1000);
    });

    $('.faqs_header').click(function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(".faq_section").offset().top - 100
        }, 1000);
    });

    /* Show/Hide Popup */
    $('.footer-popup-section').click(function () {
        if ($('.plan-popup').hasClass('hidden')) {
            $('.plan-popup').removeClass('hidden');
            $('.popup-overlay').show();
        }
        else {
            $('.plan-popup').addClass('hidden');
            $('.popup-overlay').hide();
        }
    })

    $('.close-popup').click(function () {
        $('.plan-popup').addClass('hidden');
        $('.popup-overlay').hide();
    })
})

$('.popup-overlay').click(function () {
    if ($('.plan-popup').hasClass('hidden')) {
        $('.plan-popup').removeClass('hidden');
        $('.popup-overlay').show();
    }
    else {
        $('.plan-popup').addClass('hidden');
        $('.popup-overlay').hide();
    }
})

window.onbeforeunload = function () {
    //unchecked your check box here.
    $("input[type='checkbox']").prop('checked', false)
};

/**!
 * <script src="js/osMobile.js"></script>
 */
$(document).ready(function () {
    const urlParams = window.location.search;
    $('.productSection_text_orderNow_btn').find('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.gutcleanseprotocal.com/fst/1_unit_biocomplete3_destination' + urlParams);

    //Starting mobile slider
    $('.carousel.mobile').carousel();

    let unitSelectedMob = 3;
    let flavorSelectedMob = 'raspberry';
    var optedinMob = false;
    var subscribePickedMob;


    //Function to Switch flavors
    var flavorSwitchMob = function() {
        if(flavorSelectedMob == 'watermelon'){
            $('.mobile_banner').removeClass('flavor-raspberry');
            $('.mobile_banner').addClass('flavor-watermelon');
            $('.mobile_banner').find('.select_flavors').removeClass('flavor-raspberry');
            $('.mobile_banner').find('.select_flavors').addClass('flavor-watermelon');
            $('.mobile_banner').find('.sel_flavor').removeClass('active');
            $('.mobile_banner').find('.sel_flavor:nth-child(1)').addClass('active');
            $('.mobile_banner').find('.buyButton.productSection_text_orderNow_btn ').removeClass('flavor-raspberry');
            //$('.mobile_banner').find('.buyButton.productSection_text_orderNow_btn ').removeClass('disabled');
            $('.mobile_banner').find('.buyButton.productSection_text_orderNow_btn ').addClass('flavor-watermelon');
            $('.mobile_banner').find('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnesswatermelon_3unit_mf_230308' + urlParams);
            $('.variable_productImageVanilla').attr('src','https://cdn.gundrymd.com/images/drg-mct-wellness-watermelon-lemonade.png');     
            $('.variable_suppFactsVanilla').attr('src','https://cdn.gundrymd.com/images/MCT_Wellness_Watermelon_SFP.png');
            $('.faq_supp_mob').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Watermelon_SFP.png');
        }
        else{
            $('.mobile_banner').removeClass('flavor-watermelon');
            $('.mobile_banner').addClass('flavor-raspberry');
            $('.mobile_banner').find('.select_flavors').removeClass('flavor-watermelon');
            $('.mobile_banner').find('.select_flavors').addClass('flavor-raspberry');
            $('.mobile_banner').find('.sel_flavor').removeClass('active');
            $('.mobile_banner').find('.sel_flavor:nth-child(2)').addClass('active');
            $('.mobile_banner').find('.buyButton.productSection_text_orderNow_btn ').removeClass('flavor-watermelon');
            //$('.mobile_banner').find('.buyButton.productSection_text_orderNow_btn ').removeClass('disabled');
            $('.mobile_banner').find('.buyButton.productSection_text_orderNow_btn ').addClass('flavor-raspberry');
            $('.mobile_banner').find('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnessraspberry_3unit_mf_230308' + urlParams);
            $('.variable_productImageVanilla').attr('src','https://cdn.gundrymd.com/images/Watermelon_Pink-opt.png');
            $('.variable_suppFactsVanilla').attr('src','https://cdn.gundrymd.com/images/MCT_Wellness_Raspberry_SFP_v0.png');
            $('.faq_supp_mob').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Raspberry_SFP_v0.png');
        }
    }

    flavorSwitchMob();
    
    // variable functions
    var packagepickmob = function () {
        var pkg = $('.pkg-pick').find(":selected").attr('id');
        var subscribe = $("input[name='subscribe']:checked").val();
        //alert(pkg);
        //Switch for value
        //alert('Unit: ' + unitSelectedMob);
        //alert('Flavor: ' + flavorSelectedMob);
        //alert('Subscribed: ' + subscribePickedMob);

        // if (flavorSelectedMob == "raspberry")
        //     $(".raspberry-disclaimer").slideDown();
        // else
        //     $(".raspberry-disclaimer").slideUp();

        if (subscribePickedMob)
            $(".plan-sub-txt").html("Monthly Subscription");
        else
            $(".plan-sub-txt").html("One-Time Payment");

        if (flavorSelectedMob == 'watermelon') {
            switch (unitSelectedMob) {
                case 1:
                    if (subscribePickedMob) {
                        //Sub Prices
                        $('.mobile_banner').find('.pinfo-initial-price').html('79.95');
                        //$('.mobile_banner').find('.pinfo-member-savings').html('5.00');
                        $('.mobile_banner').find('.pinfo-instant-savings').html('35.00');
                        $('.mobile_banner').find('.pinfo-final-price').html('44.95');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.sub-price').html('44.95');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.reg-price').html('49.95')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnesswatermelon_1unitsub_mf_230308' + urlParams);
                    }
                    else {
                        //One-Time Prices
                        $('.mobile_banner').find('.pinfo-initial-price').html('79.95');
                        //$('.mobile_banner').find('.pinfo-member-savings').html('5.00');
                        $('.mobile_banner').find('.pinfo-instant-savings').html('30.00');
                        $('.mobile_banner').find('.pinfo-final-price').html('49.95');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.sub-price').html('44.95');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.reg-price').html('49.95')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnesswatermelon_1unit_mf_230308' + urlParams);
                    }
                    break;
                case 3:
                    if (subscribePickedMob) {
                        //Sub Prices
                        $('.mobile_banner').find('.pinfo-initial-price').html('239.85');
                        //$('.mobile_banner').find('.pinfo-member-savings').html('15.00');
                        $('.mobile_banner').find('.pinfo-instant-savings').html('120.00');
                        $('.mobile_banner').find('.pinfo-final-price').html('119.85');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.sub-price').html('119.85');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.reg-price').html('139.85')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnesswatermelon_3unitsub_mf_230308' + urlParams);
                    }
                    else {
                        //One-Time Prices
                        $('.mobile_banner').find('.pinfo-initial-price').html('239.85');
                        //$('.mobile_banner').find('.pinfo-member-savings').html('15.00');
                        $('.mobile_banner').find('.pinfo-instant-savings').html('100.00');
                        $('.mobile_banner').find('.pinfo-final-price').html('139.85');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.sub-price').html('119.85');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.reg-price').html('139.85')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnesswatermelon_3unit_mf_230308' + urlParams);
                    }
                    break;
                default:
                    if (subscribePickedMob) {
                        //Sub Prices
                        $('.mobile_banner').find('.pinfo-initial-price').html('479.70');
                        //$('.mobile_banner').find('.pinfo-member-savings').html('30.00');
                        $('.mobile_banner').find('.pinfo-instant-savings').html('258.00');
                        $('.mobile_banner').find('.pinfo-final-price').html('221.70');
                        $('.sticky-footer-mobile').find('.sub-section').find('.sub-price').html('221.70');
                        $('.sticky-footer-mobile').find('.sub-section').find('.reg-price').html('269.70')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnesswatermelon_6unitsub_mf_230308' + urlParams);
                    }
                    else {
                        //One-Time Prices
                        $('.mobile_banner').find('.pinfo-initial-price').html('479.70');
                        //$('.mobile_banner').find('.pinfo-member-savings').html('30.00');
                        $('.mobile_banner').find('.pinfo-instant-savings').html('210.00');
                        $('.mobile_banner').find('.pinfo-final-price').html('269.70');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.sub-price').html('221.70');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.reg-price').html('269.70')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnesswatermelon_6unit_mf_230308' + urlParams);
                    }
            }
        }
        else {
            //Raspberry
            switch (unitSelectedMob) {
                case 1:
                    if (subscribePickedMob) {
                        //Sub Prices
                        $('.mobile_banner').find('.pinfo-initial-price').html('79.95');
                        //$('.mobile_banner').find('.pinfo-member-savings').html('5.00');
                        $('.mobile_banner').find('.pinfo-instant-savings').html('35.00');
                        $('.mobile_banner').find('.pinfo-final-price').html('44.95');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.sub-price').html('44.95');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.reg-price').html('49.95')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnessraspberry_1unitsub_mf_230308' + urlParams);
                    }
                    else {
                        //One-Time Prices
                        $('.mobile_banner').find('.pinfo-initial-price').html('79.95');
                        //$('.mobile_banner').find('.pinfo-member-savings').html('5.00');
                        $('.mobile_banner').find('.pinfo-instant-savings').html('30.00');
                        $('.mobile_banner').find('.pinfo-final-price').html('49.95');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.sub-price').html('44.95');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.reg-price').html('49.95')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnessraspberry_1unit_mf_230308' + urlParams);
                    }
                    break;
                case 3:
                    if (subscribePickedMob) {
                        //Sub Prices
                        $('.mobile_banner').find('.pinfo-initial-price').html('239.85');
                        //$('.mobile_banner').find('.pinfo-member-savings').html('15.00');
                        $('.mobile_banner').find('.pinfo-instant-savings').html('120.00');
                        $('.mobile_banner').find('.pinfo-final-price').html('119.85');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.sub-price').html('119.85');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.reg-price').html('139.85')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnessraspberry_3unitsub_mf_230308' + urlParams);
                    }
                    else {
                        //One-Time Prices
                        $('.mobile_banner').find('.pinfo-initial-price').html('239.85');
                        //$('.mobile_banner').find('.pinfo-member-savings').html('15.00');
                        $('.mobile_banner').find('.pinfo-instant-savings').html('100.00');
                        $('.mobile_banner').find('.pinfo-final-price').html('139.85');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.sub-price').html('119.85');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.reg-price').html('139.85')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnessraspberry_3unit_mf_230308' + urlParams);
                    }
                    break;
                default:
                    if (subscribePickedMob) {
                        //Sub Prices
                        $('.mobile_banner').find('.pinfo-initial-price').html('479.70');
                        //$('.mobile_banner').find('.pinfo-member-savings').html('30.00');
                        $('.mobile_banner').find('.pinfo-instant-savings').html('258.00');
                        $('.mobile_banner').find('.pinfo-final-price').html('221.70');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.sub-price').html('221.70');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.reg-price').html('269.70')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnessraspberry_6unitsub_mf_230308' + urlParams);
                    }
                    else {
                        //One-Time Prices
                        $('.mobile_banner').find('.pinfo-initial-price').html('479.70');
                        //$('.mobile_banner').find('.pinfo-member-savings').html('30.00');
                        $('.mobile_banner').find('.pinfo-instant-savings').html('210.00');
                        $('.mobile_banner').find('.pinfo-final-price').html('269.70');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.sub-price').html('221.70');
                        //$('.sticky-footer-mobile').find('.sub-section').find('.reg-price').html('269.70')
                        $('.productSection_text_orderNow_btn').attr('data-link', 'https://www2.thehealthyfat.com/fst/d_mctwellnessraspberry_6unit_mf_230308' + urlParams);
                    }
            }
        }
    }
    

    //Header
    /*$(window).scroll(function() {

        var scroll = $(window).scrollTop();
        var topOffer = parseInt($('.stickTop').css('height'));
        if (scroll >= topOffer) {
            $(".stickTop").addClass("release");
        }
        else{
            $(".stickTop").removeClass("release");
        }
    });*/
    //missing );


    //Package Unit Select
    $('.sticky-footer-mobile').find('.pkg-unit').click(function () {
        unitSelectedMob = parseInt($(this).attr('data-unit'));
        var unitId = '#' + $(this).attr('id');
        $('.sticky-footer-mobile').find('.pkg-unit').removeClass('active');
        $(this).addClass('active');
        $('.mobile_banner').find('.sel_qty').removeClass('active');
        $('.mobile_banner').find(unitId).addClass('active');
        packagepickmob();
    })

    $('.sticky-footer-mobile').find('.sub-section').click(function () {
        var subscriptionId = '#' + $(this).attr('id');
        $('.sticky-footer-mobile').find('.sub-section').removeClass('active');
        $('.mobile_banner').find('.sel_pay').removeClass('active');
        $(this).addClass('active');
        $('.mobile_banner').find(subscriptionId).addClass('active');
        if ($(this).attr('id') == 'onetime') {
            subscribePickedMob = false;
            $('.productSection_text_orderNow_btn').removeClass('disabled');
            $('.sticky-footer-mobile').find('.cart-section').removeClass('disabled');
            $('.sticky-footer-mobile').find('.subdisclaimer').removeClass('active');
            $('.mobile_banner').find('.sub-check').prop("checked", false);
            $('.sticky-footer-mobile').find('.sub-check').prop("checked", false);
            $('.sticky-footer-mobile').find('label').removeClass('addCheck');
            $('.mobile_banner').find('label').removeClass('addCheck');
            optedinMob = false;
            $('.mobile_banner').find('.subdisclaimer').removeClass('active');
            if (!$('.sticky-footer-mobile').find('.onetime-container').hasClass('active')) {
                $('.sticky-footer-mobile').find('.onetime-container').addClass('active');
            }
        }
        else {
            subscribePickedMob = true;
            if (optedinMob == false) {
                $('.productSection_text_orderNow_btn').addClass('disabled');
                $('.sticky-footer-mobile').find('.cart-section').addClass('disabled');
            }
            $('.sticky-footer-mobile').find('.onetime-container').removeClass('active');
            if (!$('.sticky-footer-mobile').find('.subdisclaimer').hasClass('active')) {
                $('.sticky-footer-mobile').find('.subdisclaimer').addClass('active');
            }
            if (!$('.mobile_banner').find('.subdisclaimer').hasClass('active')) {
                $('.mobile_banner').find('.subdisclaimer').addClass('active');
            }
        }
        packagepickmob();
    });

    $('.mobile_banner').find('.sel_pay').click(function () {
        var subscriptionId = '#' + $(this).attr('id');
        $('.sticky-footer-mobile').find('.sub-section').removeClass('active');
        $('.mobile_banner').find('.sel_pay').removeClass('active');
        $(this).addClass('active');
        $('.sticky-footer-mobile').find(subscriptionId).addClass('active');
        if ($(this).attr('id') == 'onetime') {
            subscribePickedMob = false;
            $('.productSection_text_orderNow_btn').removeClass('disabled');
            $('.sticky-footer-mobile').find('.cart-section').removeClass('disabled');
            $('.sticky-footer-mobile').find('.subdisclaimer').removeClass('active');
            $('.mobile_banner').find('.sub-check').prop("checked", false);
            $('.sticky-footer-mobile').find('.sub-check').prop("checked", false);
            $('.sticky-footer-mobile').find('label').removeClass('addCheck');
            $('.mobile_banner').find('label').removeClass('addCheck');
            optedinMob = false;
            $('.mobile_banner').find('.subdisclaimer').removeClass('active');
            if (!$('.sticky-footer-mobile').find('.onetime-container').hasClass('active')) {
                $('.sticky-footer-mobile').find('.onetime-container').addClass('active');
            }
        }
        else {
            subscribePickedMob = true;
            if (optedinMob == false) {
                $('.productSection_text_orderNow_btn').addClass('disabled');
                $('.sticky-footer-mobile').find('.cart-section').addClass('disabled');
            }
            $('.sticky-footer-mobile').find('.onetime-container').removeClass('active');
            if (!$('.sticky-footer-mobile').find('.subdisclaimer').hasClass('active')) {
                $('.sticky-footer-mobile').find('.subdisclaimer').addClass('active');
            }
            if (!$('.mobile_banner').find('.subdisclaimer').hasClass('active')) {
                $('.mobile_banner').find('.subdisclaimer').addClass('active');
            }
        }
        packagepickmob();
    });

    $('.sticky-footer-mobile').find('.pkg-flavor').click(function () {
        //Change Active Flavor, rename popup-body
        flavorSelectedMob = $(this).attr('data-flavor');
        flavorId = '#' + flavorSelectedMob;
        //console.log(flavorId);
        var oldFlavor = 'flavor-' + $('.pkg-flavor.active').attr('data-flavor');
        /*console.log(oldFlavor);*/
        $('.sticky-footer-mobile').find('.popup-body').removeClass(oldFlavor);
        $('.mobile_banner').removeClass(oldFlavor);
        $('.sticky-footer-mobile').find('.cart-section').removeClass(oldFlavor);
        $('.sticky-footer-mobile').find('.cart-section').addClass('flavor-' + flavorSelectedMob);
        if (flavorSelectedMob == 'raspberry') {
            $('.mobile_banner').find('.carousel-indicators').find('.variable_productImageVanilla').attr('src', 'https://cdn.gundrymd.com/images/Watermelon_Pink-opt.png');
            $('.mobile_banner').find('.carousel-inner').find('.variable_productImageVanilla').attr('src', 'https://cdn.gundrymd.com/images/Watermelon_Pink-opt.png');
            $('.mobile_banner').find('.carousel-indicators').find('.variable_suppFactsVanilla').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Raspberry_SFP_v0.png');
            $('.mobile_banner').find('.carousel-inner').find('.variable_suppFactsVanilla').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Raspberry_SFP_v0.png');
            $('.faq_supp_mob').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Raspberry_SFP_v0.png');
        }
        else {
            $('.mobile_banner').find('.carousel-indicators').find('.variable_productImageVanilla').attr('src', 'https://cdn.gundrymd.com/images/drg-mct-wellness-watermelon-lemonade.png');
            $('.mobile_banner').find('.carousel-inner').find('.variable_productImageVanilla').attr('src', 'https://cdn.gundrymd.com/images/drg-mct-wellness-watermelon-lemonade.png');
            $('.mobile_banner').find('.carousel-indicators').find('.variable_suppFactsVanilla').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Watermelon_SFP.png');
            $('.mobile_banner').find('.carousel-inner').find('.variable_suppFactsVanilla').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Watermelon_SFP.png');
            $('.faq_supp_mob').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Watermelon_SFP.png');
        }
        $('.sticky-footer-mobile').find('.popup-body').addClass('flavor-' + flavorSelectedMob);
        $('.mobile_banner').addClass('flavor-' + flavorSelectedMob);
        $('.sticky-footer-mobile').find('.pkg-flavor').removeClass('active');
        $('.mobile_banner').find('.sel_flavor').removeClass('active');
        $(this).addClass('active');
        $('.mobile_banner').find(flavorId).addClass('active');
        packagepickmob();
    })

    //Banner Options
    //Package Unit Select
    $('.mobile_banner').find('.sel_qty').click(function () {
        unitSelectedMob = parseInt($(this).attr('data-unit'));
        var unitId = '#' + $(this).attr('id');
        $('.sticky-footer-mobile').find('.pkg-unit').removeClass('active');
        $('.sticky-footer-mobile').find(unitId).addClass('active');
        $('.mobile_banner').find('.sel_qty').removeClass('active');
        $('.mobile_banner').find('.sel_qty_container').removeClass('active');
        $(this).parent('.sel_qty_container').addClass('active');
        $(this).addClass('active');
        packagepickmob();
    })
    $('.mobile_banner').find('.sel_qty_flag').click(function () {
        $(this).parent('.sel_qty_container').find('.sel_qty').click();
    })

    $('.mobile_banner').find('.sel_flavor').click(function () {
        //Change Active Flavor, rename popup-body
        flavorSelectedMob = $(this).attr('data-flavor');
        flavorId = '#' + flavorSelectedMob;
        //console.log(flavorId);
        var oldFlavor = 'flavor-' + $('.pkg-flavor.active').attr('data-flavor');
        //console.log(oldFlavor);
        $('.sticky-footer-mobile').find('.popup-body').removeClass(oldFlavor);
        $('.mobile_banner').removeClass(oldFlavor);
        $('.sticky-footer-mobile').find('.cart-section').removeClass(oldFlavor);
        $('.sticky-footer-mobile').find('.cart-section').addClass('flavor-' + flavorSelectedMob);
        if (flavorSelectedMob == 'raspberry') {
            $('.mobile_banner').find('.carousel-indicators').find('.variable_productImageVanilla').attr('src', 'https://cdn.gundrymd.com/images/Watermelon_Pink-opt.png');
            $('.mobile_banner').find('.carousel-inner').find('.variable_productImageVanilla').attr('src', 'https://cdn.gundrymd.com/images/Watermelon_Pink-opt.png');
            $('.mobile_banner').find('.carousel-indicators').find('.variable_suppFactsVanilla').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Raspberry_SFP_v0.png');
            $('.mobile_banner').find('.carousel-inner').find('.variable_suppFactsVanilla').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Raspberry_SFP_v0.png');
            $('.faq_supp_mob').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Raspberry_SFP_v0.png');
        }
        else {
            $('.mobile_banner').find('.carousel-indicators').find('.variable_productImageVanilla').attr('src', 'https://cdn.gundrymd.com/images/drg-mct-wellness-watermelon-lemonade.png');
            $('.mobile_banner').find('.carousel-inner').find('.variable_productImageVanilla').attr('src', 'https://cdn.gundrymd.com/images/drg-mct-wellness-watermelon-lemonade.png');
            $('.mobile_banner').find('.carousel-indicators').find('.variable_suppFactsVanilla').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Watermelon_SFP.png');
            $('.mobile_banner').find('.carousel-inner').find('.variable_suppFactsVanilla').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Watermelon_SFP.png');
            $('.faq_supp_mob').attr('src', 'https://cdn.gundrymd.com/images/MCT_Wellness_Watermelon_SFP.png');
        }
        $('.sticky-footer-mobile').find('.popup-body').addClass('flavor-' + flavorSelectedMob);
        $('.mobile_banner').addClass('flavor-' + flavorSelectedMob);
        $('.sticky-footer-mobile').find('.pkg-flavor').removeClass('active');
        $('.mobile_banner').find('.sel_flavor').removeClass('active');
        $(this).addClass('active');
        $('.sticky-footer-mobile').find(flavorId).addClass('active');
        packagepickmob();
    })

    $('.productSection_text_orderNow_btn').click(function () {
        if (!$(this).hasClass('disabled')) {
            window.location.href = $(this).attr('data-link');
        }
        else {
            $('.subdis-top').addClass('with-border');

            if (window.innerWidth > 1024)
                $('.plan-popup').removeClass('hidden');
        }
    })

    $('.sticky-footer-mobile').find('.sub-label-opt').click(function () {
        //alert('runnign');
        var checkedif = $('.sticky-footer-mobile').find('.sub-label-opt').hasClass('addCheck');
        //alert(checkedif);
        if (!checkedif) {
            $('.productSection_text_orderNow_btn').removeClass('disabled');
            $('.sticky-footer-mobile').find('.cart-section').removeClass('disabled');
            optedinMob = true;
            $('.mobile_banner').find('.subdis-top').find('label').addClass('addCheck');
            $('.sticky-footer-mobile').find('.subdis-top').find('label').addClass('addCheck');
            $('.subdis-top').removeClass('with-border');
            //$('.check-png').show();
        }
        else {
            //alert('here');
            $('.productSection_text_orderNow_btn').addClass('disabled');
            $('.sticky-footer-mobile').find('.cart-section').addClass('disabled');
            optedinMob = false;
            //$('.check-png').hide();
            $('.mobile_banner').find('.subdis-top').find('label').removeClass('addCheck');
            $('.sticky-footer-mobile').find('.sub-label-opt').removeClass('addCheck');
        }
        /*if(this.checked) {
            var returnVal = confirm("Are you sure?");
            $(this).prop("checked", returnVal);
        }
        $('#textbox1').val(this.checked);*/
    });

    $('.mobile_banner').find('.sub-label').click(function () {
        //alert('runnign');
        var checkedif = $('.sticky-footer-mobile').find('.sub-label-opt').hasClass('addCheck');
        //alert(checkedif);
        if (!checkedif) {
            $('.productSection_text_orderNow_btn').removeClass('disabled');
            $('.sticky-footer-mobile').find('.cart-section').removeClass('disabled');
            optedinMob = true;
            //$('.check-png').show();
            $('.mobile_banner').find('.subdis-top').find('label').addClass('addCheck');
            $('.sticky-footer-mobile').find('.subdis-top').find('label').addClass('addCheck');
        }
        else {
            //alert('here');
            $('.productSection_text_orderNow_btn').addClass('disabled');
            $('.sticky-footer-mobile').find('.cart-section').addClass('disabled');
            optedinMob = false;
            //$('.check-png').hide();
            $('.mobile_banner').find('.subdis-top').find('label').removeClass('addCheck');
            $('.sticky-footer-mobile').find('.sub-label-opt').removeClass('addCheck');
        }
    });
    $('.mobile_banner').find('.sub-label-opt').click(function () {
        //alert('runnign');
        var checkedif = $('.sticky-footer-mobile').find('.sub-label-opt').hasClass('addCheck');
        //alert(checkedif);
        if (!checkedif) {
            $('.productSection_text_orderNow_btn').removeClass('disabled');
            $('.sticky-footer-mobile').find('.cart-section').removeClass('disabled');
            optedinMob = true;
            //$('.check-png').show();
            $('.mobile_banner').find('.subdis-top').find('label').addClass('addCheck');
            $('.sticky-footer-mobile').find('.subdis-top').find('label').addClass('addCheck');
        }
        else {
            //alert('here');
            $('.productSection_text_orderNow_btn').addClass('disabled');
            $('.sticky-footer-mobile').find('.cart-section').addClass('disabled');
            optedinMob = false;
            //$('.check-png').hide();
            $('.mobile_banner').find('.subdis-top').find('label').removeClass('addCheck');
            $('.sticky-footer-mobile').find('.sub-label-opt').removeClass('addCheck');
        }
    });

    //Pick
    $('.product_section_mob').find(".pkg-pick").change(function () {
        //alert('yiad');
        packagepickmobmob();
    });

    $('.product_section_mob').find('.sub-section').click(function () {
        var idvalue = $(this).attr('id');
        var ifcheck = $(this).hasClass('active');
        var checkedsub = $('.product_section_mob').find('.sub-check').prop("checked");
        if (!ifcheck) {
            $('.product_section_mob').find('.sub-section').removeClass('active');
            $(this).addClass('active');
            $(this).children('.radio-sub').prop("checked", true);
            if (idvalue == 'subscribe') {
                $('.subdisclaimer').show();
                if (!checkedsub) {
                    $('.productSection_text_orderNow_btn').addClass('disabled');
                }
                //$('.cart-btn').addClass('noaction');
            }
            else {
                $('.product_section_mob').find('.subdisclaimer').hide();
                $('.productSection_text_orderNow_btn').removeClass('disabled');
                $('.product_section_mob').find('.sub-check').prop("checked", false);
                //$('.cart-btn').removeClass('noaction');
            }
        }
        packagepickmobmob();
    })

    $('.product_section_mob').find('#purchase-form-desk').submit(function () {
        if (!$('.productSection_text_orderNow_btn').hasClass('disabled')) {
            var link = $('.productSection_text_orderNow_btn').attr('data-link');
            window.location.href = link;
        }
    })

    $('.product_section_mob').find('.sub-check').change(function () {
        if (this.checked) {
            $('.productSection_text_orderNow_btn').removeClass('disabled');
            $('.product_section_mob').find('.check-png').show();
        }
        else {
            $('.productSection_text_orderNow_btn').addClass('disabled');
            $('.product_section_mob').find('.check-png').hide();
        }
    });

    //FAQ Section
    $(".question-div").click(function () {
        $(this).find(".rotate").toggleClass("transition");
        $(this).find(".hidden-answer").slideToggle(1200, function () {
            $(this).find(".hidden-answer").toggleClass("show-reviews");
        });
    });


    $('.header_cta_mob').click(function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(".product_section_mob").offset().top
        }, 1000);
    });

    $('.productSection_text_orderScroll_mob').click(function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(".product_section_mob").offset().top
        }, 1000);
    });

    $('.orderpage_btnB_mob').click(function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(".product_section_mob").offset().top
        }, 1000);
    });
});